import React from "react";
import { element, string, oneOfType } from "prop-types";

const Html = ({ Tag = "div", children, ...props }) => (
	<Tag dangerouslySetInnerHTML={{ __html: children }} {...props} />
);

Html.propTypes = {
	Tag: oneOfType([string, element]),
	children: string,
};

export default Html;
